import { render } from "./Telephone.vue?vue&type=template&id=2b83ff5a&scoped=true&ts=true"
import script from "./Telephone.vue?vue&type=script&lang=ts"
export * from "./Telephone.vue?vue&type=script&lang=ts"

import "./Telephone.vue?vue&type=style&index=0&id=2b83ff5a&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2b83ff5a"]])

export default __exports__